import React, { Dispatch, SetStateAction } from "react";
import { useState } from "react";
import { Box, Input } from "@chakra-ui/react";
import { colors, parsingPhoneNumber } from "goi_common";
import ConsultPrivacyAgreement from "@/components/consult/ConsultPrivacyAgreement";

export default function ConsultPhoneFormSection({
  phoneNumber,
  setPhoneNumber,
  privateAgree,
  setPrivateAgree,
  marketingAgree,
  setMarketingAgree,
}: {
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  setPrivateAgree: Dispatch<SetStateAction<boolean>>;
  privateAgree: boolean;
  marketingAgree: boolean;
  setMarketingAgree: Dispatch<SetStateAction<boolean>>;
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <Box>
      <Box className="subtitle_16_b" padding="0 0 12px 0" textAlign="center">
        {"상담하신 분께만 추가 혜택 안내드려요"}
      </Box>
      <Input
        value={phoneNumber}
        onChange={(event) =>
          setPhoneNumber(parsingPhoneNumber(event.target.value))
        }
        placeholder="010-1234-1234"
        css={{
          padding: "10px 16px",
          borderRadius: "8px",
          border: `1px solid ${colors.gray300}`,
          backgroundColor: colors.white,
          fontSize: "16px",
        }}
      />
      <Box padding="8px 0 0">
        <ConsultPrivacyAgreement
          privateAgree={privateAgree}
          setPrivateAgree={setPrivateAgree}
          marketingAgree={marketingAgree}
          setMarketingAgree={setMarketingAgree}
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
        />
      </Box>
    </Box>
  );
}
